    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="盒子:">
                            <el-select v-model="table.where.box_id" filterable placeholder="请选择">
                                <el-option v-for="item in custom_box_list" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>







                        <el-form-item label="状态:">
                            <el-select v-model="table.where.status" filterable placeholder="请选择">
                                <el-option label="显示" value="1"></el-option>
                                <el-option label="不显示" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="文字字号:">
                            <el-input-number v-model="table.where.text_size" placeholder="请输入文字字号" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="文字的最大宽度 文字个数:">
                            <el-input-number v-model="table.where.text_w" placeholder="请输入文字的最大宽度 文字个数"
                                :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="文字 X 轴坐标:">
                            <el-input-number v-model="table.where.text_x" placeholder="请输入文字 X 轴坐标" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="文字 Y 轴坐标:">
                            <el-input-number v-model="table.where.text_y" placeholder="请输入文字 Y 轴坐标" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="目标 X 轴坐标:">
                            <el-input-number v-model="table.where.add_x" placeholder="请输入目标 X 轴坐标" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="目标 Y 轴坐标:">
                            <el-input-number v-model="table.where.add_y" placeholder="请输入目标 Y 轴坐标" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="目标 宽度:">
                            <el-input-number v-model="table.where.src_w" placeholder="请输入目标 宽度" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="目标 高度:">
                            <el-input-number v-model="table.where.src_h" placeholder="请输入目标 高度" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="版本状态:">
                            <el-input-number v-model="table.where.pb_type" placeholder="请输入版本状态" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="0 不偏移 1 左 上 2 右 下 3 折行:">
                            <el-input-number v-model="table.where.skewing" placeholder="请输入0 不偏移 1 左 上 2 右 下 3 折行"
                                :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="skewing 为1,2=>偏移角度 3=>行数:">
                            <el-input-number v-model="table.where.skewing_angle"
                                placeholder="请输入skewing 为1,2=>偏移角度 3=>行数" :controls="false" controls-position="right"
                                class="ele-fluid ele-text-left" clearable />
                        </el-form-item>


                        <el-form-item label="颜色:">
                            <el-input v-model="table.where.font_color" placeholder="请输入颜色" clearable />
                        </el-form-item>

                        <el-form-item label="是否有logo:">
                            <el-select v-model="table.where.img_status" filterable placeholder="请选择">
                                <el-option label="有图片" value="1"></el-option>
                                <el-option label="没有图片" value="0"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="输入提示:">
                            <el-input v-model="table.where.placeholder" placeholder="请输入输入提示" clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:customboxresource:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:customboxresource:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:customboxresource:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="box_id" label="盒子" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.box_id_info" :key="index">{{item.name}}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="bottle_image" label="礼盒展示图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.bottle_image"
                                    :preview-src-list="[row.bottle_image]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="front_logo_image" label="前视带Logo图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.front_logo_image"
                                    :preview-src-list="[row.front_logo_image]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="logo" label="默认logo图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.logo"
                                    :preview-src-list="[row.logo]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="front_view_image" label="前视图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.front_view_image"
                                    :preview-src-list="[row.front_view_image]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="rear_view_image" label="后视图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.rear_view_image"
                                    :preview-src-list="[row.rear_view_image]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="bottle_cap_image" label="瓶盖图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.bottle_cap_image"
                                    :preview-src-list="[row.bottle_cap_image]">
                                </el-image>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                    :inactive-value="0" />
                            </template>
                        </el-table-column>

                        <el-table-column prop="text_size" label="文字字号" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="text_w" label="文字的最大宽度 文字个数" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="text_x" label="文字 X 轴坐标" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="text_y" label="文字 Y 轴坐标" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="add_x" label="目标 X 轴坐标" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="add_y" label="目标 Y 轴坐标" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="src_w" label="目标 宽度" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="src_h" label="目标 高度" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="pb_type" label="版本状态" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="skewing" label="0 不偏移 1 左 上 2 右 下 3 折行" sortable="custom"
                            show-overflow-tooltip min-width="120" />

                        <el-table-column prop="skewing_angle" label="skewing 为1,2=>偏移角度 3=>行数" sortable="custom"
                            show-overflow-tooltip min-width="120" />


                        <el-table-column prop="font_color" label="颜色" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="img_status" label="是否有logo" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-switch v-model="row.img_status" @change="editStatus(row,'img_status')"
                                    :active-value="1" :inactive-value="0" />
                            </template>
                        </el-table-column>

                        <el-table-column prop="placeholder" label="输入提示" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="box_id_info.name" label="模型名称" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.box_id_info" :key="index">
                                    {{ item.name }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:customboxresource:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此定制盒子资源吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:customboxresource:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改定制盒子资源':'添加定制盒子资源'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                    <el-form-item label="盒子:" prop="box_id">
                        <el-select v-model="editForm.box_id" filterable placeholder="请选择">
                            <el-option v-for="item in custom_box_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="礼盒展示图:" prop="bottle_image">
                        <ele-uploadimage :limit="1" v-model="editForm.bottle_image"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="前视带Logo图:" prop="front_logo_image">
                        <ele-uploadimage :limit="1" v-model="editForm.front_logo_image"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="默认logo图:" prop="logo">
                        <ele-uploadimage :limit="1" v-model="editForm.logo"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="前视图:" prop="front_view_image">
                        <ele-uploadimage :limit="1" v-model="editForm.front_view_image"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="后视图:" prop="rear_view_image">
                        <ele-uploadimage :limit="1" v-model="editForm.rear_view_image"></ele-uploadimage>

                    </el-form-item>


                   <!-- <el-form-item label="瓶盖图:" prop="bottle_cap_image">
                        <ele-uploadimage :limit="1" v-model="editForm.bottle_cap_image"></ele-uploadimage>

                    </el-form-item> -->


                    <el-form-item label="状态:" prop="status">
                        <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                            :inactive-value="0" />

                    </el-form-item>


                    <el-form-item label="文字字号:" prop="text_size">
                        <el-input-number v-model="editForm.text_size" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入文字字号" clearable />
                    </el-form-item>

                    <el-form-item label="文字的最大宽度 文字个数:" prop="text_w">
                        <el-input-number v-model="editForm.text_w" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入文字的最大宽度 文字个数" clearable />
                    </el-form-item>

                    <el-form-item label="文字 X 轴坐标:" prop="text_x">
                        <el-input-number v-model="editForm.text_x" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入文字 X 轴坐标" clearable />
                    </el-form-item>

                    <el-form-item label="文字 Y 轴坐标:" prop="text_y">
                        <el-input-number v-model="editForm.text_y" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入文字 Y 轴坐标" clearable />
                    </el-form-item>

                    <el-form-item label="目标 X 轴坐标:" prop="add_x">
                        <el-input-number v-model="editForm.add_x" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入目标 X 轴坐标" clearable />
                    </el-form-item>

                    <el-form-item label="目标 Y 轴坐标:" prop="add_y">
                        <el-input-number v-model="editForm.add_y" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入目标 Y 轴坐标" clearable />
                    </el-form-item>

                    <el-form-item label="目标 宽度:" prop="src_w">
                        <el-input-number v-model="editForm.src_w" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入目标 宽度" clearable />
                    </el-form-item>

                    <el-form-item label="目标 高度:" prop="src_h">
                        <el-input-number v-model="editForm.src_h" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入目标 高度" clearable />
                    </el-form-item>

                    <el-form-item label="版本状态:" prop="pb_type">
                        <el-input-number v-model="editForm.pb_type" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入版本状态" clearable />
                    </el-form-item>

                    <el-form-item label="0 不偏移 1 左 上 2 右 下 3 折行:" prop="skewing">
                        <el-input-number v-model="editForm.skewing" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入0 不偏移 1 左 上 2 右 下 3 折行"
                            clearable />
                    </el-form-item>

                    <el-form-item label="skewing 为1,2=>偏移角度 3=>行数:" prop="skewing_angle">
                        <el-input-number v-model="editForm.skewing_angle" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入skewing 为1,2=>偏移角度 3=>行数"
                            clearable />
                    </el-form-item>



                    <el-form-item label="颜色:" prop="font_color">
                        <el-input v-model="editForm.font_color" placeholder="请输入颜色" clearable />
                    </el-form-item>


                    <el-form-item label="是否有logo:" prop="img_status">
                        <el-switch v-model="editForm.img_status" active-text="是" inactive-text="否" :active-value="1"
                            :inactive-value="0" />

                    </el-form-item>

                    <el-form-item label="输入提示:" prop="placeholder">
                        <el-input v-model="editForm.placeholder" placeholder="请输入输入提示" clearable />
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'

        export default {
            name: "SysCustomBoxResource",
            components: {
                EleUploadimage,
            },
            data() {
                return {
                    table: {
                        url: '/custom/CustomBoxResource/index',
                        where: {
                            "bottle_image": [],
                            "front_logo_image": [],
                            "logo": [],
                            "front_view_image": [],
                            "rear_view_image": [],
                            "bottle_cap_image": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "bottle_image": [],
                        "front_logo_image": [],
                        "logo": [],
                        "front_view_image": [],
                        "rear_view_image": [],
                        "bottle_cap_image": []
                    }, // 表单数据
                    editFormTemp: {
                        "bottle_image": [],
                        "front_logo_image": [],
                        "logo": [],
                        "front_view_image": [],
                        "rear_view_image": [],
                        "bottle_cap_image": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    custom_box_list: [],
                    editRules: { // 表单验证规则

                        box_id: [{
                            required: true,
                            message: '请选择盒子',
                            trigger: 'blur'
                        }],


                        bottle_image: [{
                            required: true,
                            message: '请上传瓶效果图',
                            trigger: 'blur'
                        }],


                        front_logo_image: [{
                            required: true,
                            message: '请上传前视带Logo图',
                            trigger: 'blur'
                        }],


                        logo: [{
                            required: true,
                            message: '请上传默认logo图',
                            trigger: 'blur'
                        }],


                        front_view_image: [{
                            required: true,
                            message: '请上传前视图',
                            trigger: 'blur'
                        }],


                        rear_view_image: [{
                            required: true,
                            message: '请上传后视图',
                            trigger: 'blur'
                        }],


                        bottle_cap_image: [{
                            required: true,
                            message: '请上传瓶盖图',
                            trigger: 'blur'
                        }],



                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        text_size: [{
                            required: true,
                            message: '请输入文字字号',
                            trigger: 'blur'
                        }],


                        text_w: [{
                            required: true,
                            message: '请输入文字的最大宽度 文字个数',
                            trigger: 'blur'
                        }],


                        text_x: [{
                            required: true,
                            message: '请输入文字 X 轴坐标',
                            trigger: 'blur'
                        }],


                        text_y: [{
                            required: true,
                            message: '请输入文字 Y 轴坐标',
                            trigger: 'blur'
                        }],


                        add_x: [{
                            required: true,
                            message: '请输入目标 X 轴坐标',
                            trigger: 'blur'
                        }],


                        add_y: [{
                            required: true,
                            message: '请输入目标 Y 轴坐标',
                            trigger: 'blur'
                        }],


                        src_w: [{
                            required: true,
                            message: '请输入目标 宽度',
                            trigger: 'blur'
                        }],


                        src_h: [{
                            required: true,
                            message: '请输入目标 高度',
                            trigger: 'blur'
                        }],


                        pb_type: [{
                            required: true,
                            message: '请输入版本状态',
                            trigger: 'blur'
                        }],


                        skewing: [{
                            required: true,
                            message: '请输入0 不偏移 1 左 上 2 右 下 3 折行',
                            trigger: 'blur'
                        }],


                        skewing_angle: [{
                            required: true,
                            message: '请输入skewing 为1,2=>偏移角度 3=>行数',
                            trigger: 'blur'
                        }],


                        font_id: [{
                            required: true,
                            message: '请选择默认字体id',
                            trigger: 'blur'
                        }],


                        font_color: [{
                            required: true,
                            message: '请输入颜色',
                            trigger: 'blur'
                        }],



                        placeholder: [{
                            required: true,
                            message: '请输入输入提示',
                            trigger: 'blur'
                        }],


                        name: [{
                            required: true,
                            message: '请输入模型名称',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.CustomBoxAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/custom/CustomBoxResource/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomBoxResource/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的定制盒子资源吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomBoxResource/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/custom/CustomBoxResource/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/custom/CustomBoxResource/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                CustomBoxAllList() {
                    this.$http.post('/custom/CustomBox/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.custom_box_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/custom/CustomBoxResource/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>